/* WA 26 — animations et interactions (maquette « Aigles 26 ») */
(() => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('w26-js');

  /* Apparition au défilement */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { (e.target.__w26 || [e.target]).forEach((t) => t.classList.add('is-in')); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });

  /* Filet de sécurité : tout ce qui est déjà dans l'écran est révélé sans attendre l'observateur */
  const revealNow = () => {
    const vh = window.innerHeight;
    document.querySelectorAll('[data-w26-reveal]:not(.is-in), .w26-lines:not(.is-in), .w26-chars:not(.is-in)').forEach((el) => {
      const r = (el.dataset.w26Reveal === 'mask' && el.parentElement ? el.parentElement : el).getBoundingClientRect();
      if (r.top < vh * 0.96 && r.bottom > 0) el.classList.add('is-in');
    });
  };
  const observe = (scope = document) => {
    scope.querySelectorAll('[data-w26-reveal], .w26-lines, .w26-chars').forEach((el) => {
      if (reduce) { el.classList.add('is-in'); return; }
      /* Un élément masqué (clip-path) n'est pas vu par l'observateur : on observe son parent */
      if (el.dataset.w26Reveal === 'mask' && el.parentElement) { (el.parentElement.__w26 ||= []).push(el); io.observe(el.parentElement); return; }
      io.observe(el);
    });
    /* Héros : on attend que les photos soient prêtes (1,2 s max) */
    scope.querySelectorAll('.w26-split').forEach((el) => {
      const imgs = [...el.querySelectorAll('.w26-split__media img')];
      const go = () => el.classList.add('is-in');
      if (reduce) return go();
      Promise.race([
        Promise.all(imgs.map((i) => (i.complete ? Promise.resolve() : i.decode().catch(() => {})))),
        new Promise((r) => setTimeout(r, 1200)),
      ]).then(go);
    });
  };

  /* Rails : flèches + état début/fin */
  const initRails = (scope = document) => {
    scope.querySelectorAll('.w26-rail').forEach((rail) => {
      const track = rail.querySelector('.w26-rail__track');
      const prev = rail.querySelector('[data-w26-prev]');
      const next = rail.querySelector('[data-w26-next]');
      if (!track || !prev || !next) return;
      const step = () => track.querySelector('.w26-card')?.getBoundingClientRect().width + 12 || 300;
      const update = () => {
        prev.disabled = track.scrollLeft < 8;
        next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
      };
      prev.onclick = () => track.scrollBy({ left: -step(), behavior: 'smooth' });
      next.onclick = () => track.scrollBy({ left: step(), behavior: 'smooth' });
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  };

  /* Ajout rapide d'une taille → ouvre le panier du thème */
  document.addEventListener('click', async (ev) => {
    const btn = ev.target.closest('[data-w26-add]');
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    btn.classList.add('is-loading');
    try {
      const prep = new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: [] } });
      document.documentElement.dispatchEvent(prep);
      const body = new FormData();
      body.set('id', btn.dataset.w26Add);
      body.set('quantity', '1');
      if (prep.detail.sections.length) body.set('sections', prep.detail.sections.join(','));
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', body, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const item = await res.json();
      if (!res.ok) throw new Error(item.description || 'Erreur');
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
      cart.sections = item.sections || {};
      document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: [item], cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart } }));
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1600);
    } catch (e) {
      window.location.href = btn.dataset.w26Url || '/cart';
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* Héros : la séparation suit la souris, les photos bougent, la page recule au défilement */
  const fine = window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:1000px)');
  document.querySelectorAll('.w26-split').forEach((split) => {
    const panels = [...split.querySelectorAll('.w26-split__panel')];
    if (panels.length !== 2 || reduce) return;
    let tx = 0.5, cx = 0.5, ty = 0.5, cy = 0.5, raf = null, inside = false;
    const tick = () => {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      const g = 0.62 + cx * 0.9; /* 0.62 → 1.52 */
      panels[0].style.setProperty('--w26-g', (2.14 - g).toFixed(3));
      panels[1].style.setProperty('--w26-g', g.toFixed(3));
      split.style.setProperty('--w26-mx', `${((cx - 0.5) * -2.2).toFixed(2)}%`);
      split.style.setProperty('--w26-my', `${((cy - 0.5) * -1.6).toFixed(2)}%`);
      panels[0].classList.toggle('is-near', cx < 0.5);
      panels[1].classList.toggle('is-near', cx >= 0.5);
      if (inside || Math.abs(tx - cx) > 0.002) raf = requestAnimationFrame(tick); else raf = null;
    };
    split.addEventListener('pointerenter', () => { if (!fine.matches) return; inside = true; split.classList.add('is-mouse'); if (!raf) raf = requestAnimationFrame(tick); });
    split.addEventListener('pointermove', (e) => { if (!fine.matches) return; const r = split.getBoundingClientRect(); tx = (e.clientX - r.left) / r.width; ty = (e.clientY - r.top) / r.height; });
    split.addEventListener('pointerleave', () => { inside = false; tx = 0.5; ty = 0.5; if (!raf) raf = requestAnimationFrame(tick); setTimeout(() => { if (!inside) { split.classList.remove('is-mouse'); panels.forEach((p) => p.classList.remove('is-near')); } }, 600); });
  });
  const heroes = [...document.querySelectorAll('.w26-split')];
  const scrollHero = () => {
    if (reduce) return;
    heroes.forEach((h) => {
      const wrap = h.parentElement.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, -wrap.top / (h.offsetHeight || 1)));
      h.style.transform = `scale(${(1 - p * 0.08).toFixed(4)})`;
      h.style.filter = `brightness(${(1 - p * 0.55).toFixed(3)})`;
      h.style.borderRadius = `${(p * 28).toFixed(1)}px ${(p * 28).toFixed(1)}px 0 0`;
    });
  };

  /* Boutons aimantés */
  document.querySelectorAll('[data-w26-mag]').forEach((b) => {
    if (reduce) return;
    const host = b.closest('.w26-split__panel') || b;
    host.addEventListener('pointermove', (e) => {
      if (!fine.matches) return;
      const r = b.getBoundingClientRect(), dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
      const d = Math.hypot(dx, dy);
      b.classList.add('is-mag');
      if (d < 140) b.style.transform = `translate(${(dx * 0.25).toFixed(1)}px, ${(dy * 0.25).toFixed(1)}px)`; else b.style.transform = '';
    });
    host.addEventListener('pointerleave', () => { b.style.transform = ''; });
  });

  /* Parallaxe douce + lookbook horizontal épinglé */
  const parallax = [...document.querySelectorAll('[data-w26-parallax]')];
  const looks = [...document.querySelectorAll('.w26-look')];
  const desktop = window.matchMedia('(min-width: 1000px)');

  const sizeLooks = () => {
    looks.forEach((look) => {
      const track = look.querySelector('.w26-look__track');
      if (!desktop.matches || reduce) { look.style.height = ''; track.style.transform = ''; return; }
      const dist = Math.max(0, track.scrollWidth - window.innerWidth);
      look.dataset.dist = dist;
      look.style.height = `${look.querySelector('.w26-look__pin').offsetHeight + dist}px`;
    });
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const vh = window.innerHeight;
      revealNow();
      scrollHero();
      parallax.forEach((img) => {
        const r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / (vh + r.height);
        img.style.transform = `translate3d(0, ${(-p * 14).toFixed(2)}%, 0)`;
      });
      if (desktop.matches && !reduce) {
        looks.forEach((look) => {
          const dist = +look.dataset.dist || 0;
          const r = look.getBoundingClientRect();
          const pin = look.querySelector('.w26-look__pin');
          const off = pin.getBoundingClientRect().top - r.top;
          const p = Math.min(1, Math.max(0, off / (r.height - pin.offsetHeight || 1)));
          look.querySelector('.w26-look__track').style.transform = `translate3d(${-p * dist}px,0,0)`;
          look.style.setProperty('--w26-p', p.toFixed(4));
          const items = look.querySelectorAll('.w26-look__item').length;
          const c = look.querySelector('[data-w26-count]');
          if (c) c.textContent = `${String(Math.min(items, Math.round(p * (items - 1)) + 1)).padStart(2, '0')} / ${String(items).padStart(2, '0')}`;
        });
      }
      ticking = false;
    });
  };

  /* Barre « livraison offerte dès 2 articles » sur la fiche produit */
  const updateShip = async (cart) => {
    const boxes = document.querySelectorAll('[data-w26-ship]');
    if (!boxes.length) return;
    try {
      cart = cart || await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
    } catch (e) { return; }
    const n = cart.item_count || 0;
    boxes.forEach((box) => {
      const goal = +box.dataset.w26Ship || 2;
      const txt = box.querySelector('[data-w26-ship-text]');
      box.style.setProperty('--w26-ship', `${Math.min(100, (n / goal) * 100)}%`);
      if (n >= goal) txt.innerHTML = '<strong>Livraison offerte</strong> sur ta commande (France).';
      else if (n === 0) txt.innerHTML = `<strong>Livraison offerte dès ${goal} articles</strong> (France).`;
      else txt.innerHTML = `Plus que <strong>${goal - n} article${goal - n > 1 ? 's' : ''}</strong> pour la livraison offerte.`;
    });
  };
  document.addEventListener('cart:change', (e) => updateShip(e.detail?.cart));

  /* Guide des tailles */
  document.addEventListener('click', (ev) => {
    const open = ev.target.closest('[data-w26-open]');
    if (open) { document.getElementById(open.dataset.w26Open)?.showModal(); return; }
    const close = ev.target.closest('[data-w26-close]');
    if (close) close.closest('dialog')?.close();
    if (ev.target.matches('dialog.w26-dialog')) ev.target.close();
  });

  const init = () => {
    observe();
    revealNow();
    setTimeout(revealNow, 300);
    setTimeout(revealNow, 1500);
    initRails();
    sizeLooks();
    onScroll();
    updateShip();
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => { sizeLooks(); onScroll(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', () => { sizeLooks(); onScroll(); });

  /* Éditeur de thème : réinitialiser une section rechargée */
  document.addEventListener('shopify:section:load', (e) => { observe(e.target); initRails(e.target); sizeLooks(); onScroll(); });
})();
